import { useMemo } from "react";
import { useHospitalData } from "@/contexts/HospitalDataProvider";
import { StatsMode } from "@/utils/models";
import type { FormRowContext } from "./locationConfigData";

/**
 * Whether the chosen department staffs its shifts by ratio ladder: its editors then show the ladder, and the ladder,
 * not the staffing targets, sets each saved row's per-day amounts (`resolveDayAmounts`). The one place it is derived.
 */
export const useCanEditRatioLadder = (): boolean => useHospitalData().chosenDepartment.statsMode === StatsMode.Ratio;

/** The chosen department as every "form → saved row" build reads it (`buildFormRow`). Stable while those fields are. */
export const useFormRowContext = (): FormRowContext => {
	const { chosenDepartment } = useHospitalData();
	const canEditRatioLadder = useCanEditRatioLadder();
	const { shift_types: shiftTypes, department_id: departmentId } = chosenDepartment;
	return useMemo(() => ({ canEditRatioLadder, shiftTypes, departmentId }), [canEditRatioLadder, shiftTypes, departmentId]);
};
